// src/components/news/NewsSection.jsx
import NewsCard from "./NewsCard";

function SkeletonRow() {
  return (
    <div className="news-card" aria-hidden="true">
      <div
        className="news-thumb"
        style={{ opacity: 0.35 }}
      />
      <div className="news-content" style={{ width: "100%" }}>
        <div
          style={{
            height: 12,
            width: "92%",
            borderRadius: 6,
            background: "rgba(255,255,255,0.08)",
          }}
        />
        <div
          style={{
            height: 12,
            width: "78%",
            borderRadius: 6,
            background: "rgba(255,255,255,0.06)",
            marginTop: 8,
          }}
        />
        <div
          style={{
            height: 10,
            width: "45%",
            borderRadius: 6,
            background: "rgba(255,255,255,0.05)",
            marginTop: 10,
          }}
        />
      </div>
    </div>
  );
}

export default function NewsSection({
  title,
  items,
  loading = false,
  error = null,
  skeletonCount = 3,
  emptyText = "Sem notícias por enquanto.",
}) {
  return (
    <section className="news-section">
      <h3>{title}</h3>

      {loading ? (
        <div className="card news-list">
          {Array.from({ length: skeletonCount }).map((_, i) => (
            <SkeletonRow key={i} />
          ))}
        </div>
      ) : error ? (
        <div className="card">
          <div className="card-title">Não foi possível carregar</div>
          <div className="card-subtitle">
            {typeof error === "string" ? error : "Tente novamente em instantes."}
          </div>
        </div>
      ) : !items?.length ? (
        <div className="card">
          <div className="card-subtitle">{emptyText}</div>
        </div>
      ) : (
        <div className="card news-list">
          {items.map((it) => (
            <NewsCard key={it.id ?? it.url} item={it} />
          ))}
        </div>
      )}
    </section>
  );
}
